import { CommandCentreVenue } from "../state/UserState";
const currentEnv = process.env.NODE_ENV ?? "development";

class UserVenuesStore {
  STORAGE_KEY = currentEnv + "ok2puserVenues";

  getVenues(): CommandCentreVenue[] | undefined {
    let venues = localStorage.getItem(this.STORAGE_KEY);

    if (venues == null) return undefined;

    return JSON.parse(venues);
  }

  storeVenues(venues: CommandCentreVenue[]) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(venues));
  }

  clearStore() {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

export default new UserVenuesStore();
